<script setup lang="ts">
const newPostModalVisible = ref(false);
const newPostModalLayout = ref<"feedback" | "new-post">("new-post");

const route = useRoute();

const openingModalFromQuery = ref(false);

watch(
  () => route.fullPath,
  () => {
    if (openingModalFromQuery.value) {
      openingModalFromQuery.value = false;
    } else {
      close();
    }
  },
);

function openModal(layout: "feedback" | "new-post" = "new-post") {
  newPostModalVisible.value = true;
  newPostModalLayout.value = layout;
}

function close() {
  newPostModalVisible.value = false;
}

onMounted(() => {
  globalOn("app::openTweetEditor", openModal);

  if (route.query.modal_to_open) {
    const layout = route.query.modal_to_open;

    // order is important here, do not think that just moving
    // the userRouter().replace higher you can get rid
    //  of openingModalFromQuery state
    // (unless you of course retested it and found out why it
    //  doesn't work to just move it)
    if (layout === "feedback" || layout === "new-post") {
      openingModalFromQuery.value = true;
      openModal(layout);
    }
    useRouter().replace({ query: {} });
  }
});

onBeforeUnmount(() => {
  globalOff("app::openTweetEditor", openModal);
});
</script>

<template>
  <LazyModalsNewPostModal
    v-if="newPostModalVisible"
    :layout="newPostModalLayout"
    @close="close"
    @tweetPosted="close"
  />
</template>
